"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaAdsCampaignApprovalStatus = exports.MetaAdsWebsiteAudienceRule = exports.MetaAdsEngagementSource = exports.MetaAdsAudienceStatus = exports.MetaAdsAudienceType = exports.MetaAdsGeoTargetingMode = exports.MetaAdsLocationType = exports.MetaAdsDistanceUnit = exports.MetaAdsAttributionWindow = exports.MetaAdsConversionEvent = exports.MetaAdsCTA = exports.MetaAdsBudgetType = exports.MetaAdsBidStrategy = exports.MetaAdsAdFormat = exports.countMetaAdsLeadFormCustomQuestions = exports.MAX_META_ADS_LEAD_FORM_CUSTOM_QUESTIONS = exports.MetaAdsLeadFormQuestionType = exports.isValidMetaAdsOptimizationGoal = exports.getDefaultMetaAdsOptimizationGoal = exports.getMetaAdsOptimizationGoals = exports.toMetaAdsDestinationType = exports.MetaAdsConversionLocation = exports.MetaAdsOptimizationGoal = exports.MetaAdsCampaignObjective = exports.MetaAdsRole = void 0;
exports.metaAdsLocationTypesForApi = metaAdsLocationTypesForApi;
var MetaAdsRole;
(function (MetaAdsRole) {
    MetaAdsRole["VIEWER"] = "viewer";
    MetaAdsRole["EDITOR"] = "editor";
    MetaAdsRole["MANAGER"] = "manager";
})(MetaAdsRole || (exports.MetaAdsRole = MetaAdsRole = {}));
// ── Campaign creation DTOs ──
var MetaAdsCampaignObjective;
(function (MetaAdsCampaignObjective) {
    MetaAdsCampaignObjective["OUTCOME_AWARENESS"] = "OUTCOME_AWARENESS";
    MetaAdsCampaignObjective["OUTCOME_TRAFFIC"] = "OUTCOME_TRAFFIC";
    MetaAdsCampaignObjective["OUTCOME_ENGAGEMENT"] = "OUTCOME_ENGAGEMENT";
    MetaAdsCampaignObjective["OUTCOME_LEADS"] = "OUTCOME_LEADS";
    MetaAdsCampaignObjective["OUTCOME_SALES"] = "OUTCOME_SALES";
})(MetaAdsCampaignObjective || (exports.MetaAdsCampaignObjective = MetaAdsCampaignObjective = {}));
var MetaAdsOptimizationGoal;
(function (MetaAdsOptimizationGoal) {
    MetaAdsOptimizationGoal["LINK_CLICKS"] = "LINK_CLICKS";
    MetaAdsOptimizationGoal["LANDING_PAGE_VIEWS"] = "LANDING_PAGE_VIEWS";
    MetaAdsOptimizationGoal["LEAD_GENERATION"] = "LEAD_GENERATION";
    MetaAdsOptimizationGoal["REACH"] = "REACH";
    MetaAdsOptimizationGoal["AD_RECALL_LIFT"] = "AD_RECALL_LIFT";
    MetaAdsOptimizationGoal["POST_ENGAGEMENT"] = "POST_ENGAGEMENT";
    MetaAdsOptimizationGoal["THRUPLAY"] = "THRUPLAY";
    MetaAdsOptimizationGoal["CONVERSATIONS"] = "CONVERSATIONS";
    MetaAdsOptimizationGoal["PAGE_LIKES"] = "PAGE_LIKES";
    MetaAdsOptimizationGoal["OFFSITE_CONVERSIONS"] = "OFFSITE_CONVERSIONS";
    MetaAdsOptimizationGoal["VALUE"] = "VALUE";
})(MetaAdsOptimizationGoal || (exports.MetaAdsOptimizationGoal = MetaAdsOptimizationGoal = {}));
var MetaAdsConversionLocation;
(function (MetaAdsConversionLocation) {
    MetaAdsConversionLocation["INSTANT_FORM"] = "ON_AD";
    MetaAdsConversionLocation["WEBSITE"] = "WEBSITE";
    MetaAdsConversionLocation["MESSENGER"] = "MESSENGER";
    MetaAdsConversionLocation["ON_POST"] = "ON_POST";
    MetaAdsConversionLocation["ON_PAGE"] = "ON_PAGE";
    MetaAdsConversionLocation["ON_VIDEO"] = "ON_VIDEO";
    MetaAdsConversionLocation["CALLS"] = "CALLS";
    MetaAdsConversionLocation["INSTAGRAM_DIRECT"] = "IG_DIRECT";
})(MetaAdsConversionLocation || (exports.MetaAdsConversionLocation = MetaAdsConversionLocation = {}));
/** Maps our stored conversion location to Meta `destination_type`. */
const toMetaAdsDestinationType = (location) => {
    switch (location) {
        case MetaAdsConversionLocation.CALLS:
            return "PHONE_CALL";
        case MetaAdsConversionLocation.INSTAGRAM_DIRECT:
            return "INSTAGRAM_DIRECT";
        default:
            return location;
    }
};
exports.toMetaAdsDestinationType = toMetaAdsDestinationType;
/**
 * Valid optimization goals for a campaign objective + conversion location.
 * Meta rejects mismatched pairs with error 2490408.
 */
const getMetaAdsOptimizationGoals = (objective, conversionLocation) => {
    switch (objective) {
        case MetaAdsCampaignObjective.OUTCOME_AWARENESS:
            return [
                { value: MetaAdsOptimizationGoal.REACH, label: "Reach" },
                {
                    value: MetaAdsOptimizationGoal.AD_RECALL_LIFT,
                    label: "Ad Recall Lift",
                },
            ];
        case MetaAdsCampaignObjective.OUTCOME_TRAFFIC:
            return [
                { value: MetaAdsOptimizationGoal.LINK_CLICKS, label: "Link Clicks" },
                {
                    value: MetaAdsOptimizationGoal.LANDING_PAGE_VIEWS,
                    label: "Landing Page Views",
                },
            ];
        case MetaAdsCampaignObjective.OUTCOME_ENGAGEMENT:
            switch (conversionLocation) {
                case MetaAdsConversionLocation.MESSENGER:
                case MetaAdsConversionLocation.INSTAGRAM_DIRECT:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.CONVERSATIONS,
                            label: "Conversations",
                        },
                    ];
                case MetaAdsConversionLocation.ON_PAGE:
                    return [
                        { value: MetaAdsOptimizationGoal.PAGE_LIKES, label: "Page Likes" },
                    ];
                case MetaAdsConversionLocation.ON_VIDEO:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.THRUPLAY,
                            label: "ThruPlay (Video Views)",
                        },
                    ];
                default:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.POST_ENGAGEMENT,
                            label: "Post Engagement",
                        },
                    ];
            }
        case MetaAdsCampaignObjective.OUTCOME_LEADS:
            switch (conversionLocation) {
                case MetaAdsConversionLocation.WEBSITE:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.OFFSITE_CONVERSIONS,
                            label: "Conversions",
                        },
                        {
                            value: MetaAdsOptimizationGoal.LINK_CLICKS,
                            label: "Link Clicks",
                        },
                        {
                            value: MetaAdsOptimizationGoal.LANDING_PAGE_VIEWS,
                            label: "Landing Page Views",
                        },
                    ];
                case MetaAdsConversionLocation.MESSENGER:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.LEAD_GENERATION,
                            label: "Lead Generation",
                        },
                        {
                            value: MetaAdsOptimizationGoal.CONVERSATIONS,
                            label: "Conversations",
                        },
                    ];
                default:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.LEAD_GENERATION,
                            label: "Lead Generation",
                        },
                    ];
            }
        case MetaAdsCampaignObjective.OUTCOME_SALES:
            switch (conversionLocation) {
                case MetaAdsConversionLocation.MESSENGER:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.CONVERSATIONS,
                            label: "Conversations",
                        },
                        {
                            value: MetaAdsOptimizationGoal.LINK_CLICKS,
                            label: "Link Clicks",
                        },
                    ];
                case MetaAdsConversionLocation.CALLS:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.LINK_CLICKS,
                            label: "Link Clicks",
                        },
                    ];
                default:
                    return [
                        {
                            value: MetaAdsOptimizationGoal.OFFSITE_CONVERSIONS,
                            label: "Conversions",
                        },
                        { value: MetaAdsOptimizationGoal.VALUE, label: "Value (ROAS)" },
                        {
                            value: MetaAdsOptimizationGoal.LINK_CLICKS,
                            label: "Link Clicks",
                        },
                    ];
            }
        default:
            return [
                { value: MetaAdsOptimizationGoal.LINK_CLICKS, label: "Link Clicks" },
            ];
    }
};
exports.getMetaAdsOptimizationGoals = getMetaAdsOptimizationGoals;
const getDefaultMetaAdsOptimizationGoal = (objective, conversionLocation) => (0, exports.getMetaAdsOptimizationGoals)(objective, conversionLocation)[0].value;
exports.getDefaultMetaAdsOptimizationGoal = getDefaultMetaAdsOptimizationGoal;
const isValidMetaAdsOptimizationGoal = (objective, optimizationGoal, conversionLocation) => (0, exports.getMetaAdsOptimizationGoals)(objective, conversionLocation).some((opt) => opt.value === optimizationGoal);
exports.isValidMetaAdsOptimizationGoal = isValidMetaAdsOptimizationGoal;
var MetaAdsLeadFormQuestionType;
(function (MetaAdsLeadFormQuestionType) {
    MetaAdsLeadFormQuestionType["EMAIL"] = "EMAIL";
    MetaAdsLeadFormQuestionType["FULL_NAME"] = "FULL_NAME";
    MetaAdsLeadFormQuestionType["PHONE_NUMBER"] = "PHONE_NUMBER";
    MetaAdsLeadFormQuestionType["CUSTOM"] = "CUSTOM";
})(MetaAdsLeadFormQuestionType || (exports.MetaAdsLeadFormQuestionType = MetaAdsLeadFormQuestionType = {}));
exports.MAX_META_ADS_LEAD_FORM_CUSTOM_QUESTIONS = 3;
const countMetaAdsLeadFormCustomQuestions = (questions) => questions.filter((q) => q.type === MetaAdsLeadFormQuestionType.CUSTOM).length;
exports.countMetaAdsLeadFormCustomQuestions = countMetaAdsLeadFormCustomQuestions;
var MetaAdsAdFormat;
(function (MetaAdsAdFormat) {
    MetaAdsAdFormat["SINGLE_IMAGE"] = "single_image";
    MetaAdsAdFormat["SINGLE_VIDEO"] = "single_video";
    MetaAdsAdFormat["CAROUSEL"] = "carousel";
})(MetaAdsAdFormat || (exports.MetaAdsAdFormat = MetaAdsAdFormat = {}));
var MetaAdsBidStrategy;
(function (MetaAdsBidStrategy) {
    MetaAdsBidStrategy["LOWEST_COST_WITHOUT_CAP"] = "LOWEST_COST_WITHOUT_CAP";
    MetaAdsBidStrategy["LOWEST_COST_WITH_BID_CAP"] = "LOWEST_COST_WITH_BID_CAP";
    MetaAdsBidStrategy["COST_CAP"] = "COST_CAP";
})(MetaAdsBidStrategy || (exports.MetaAdsBidStrategy = MetaAdsBidStrategy = {}));
var MetaAdsBudgetType;
(function (MetaAdsBudgetType) {
    MetaAdsBudgetType["DAILY"] = "DAILY";
    MetaAdsBudgetType["LIFETIME"] = "LIFETIME";
})(MetaAdsBudgetType || (exports.MetaAdsBudgetType = MetaAdsBudgetType = {}));
var MetaAdsCTA;
(function (MetaAdsCTA) {
    MetaAdsCTA["LEARN_MORE"] = "LEARN_MORE";
    MetaAdsCTA["SHOP_NOW"] = "SHOP_NOW";
    MetaAdsCTA["SIGN_UP"] = "SIGN_UP";
    MetaAdsCTA["CONTACT_US"] = "CONTACT_US";
    MetaAdsCTA["GET_QUOTE"] = "GET_QUOTE";
    MetaAdsCTA["BOOK_NOW"] = "BOOK_NOW";
    MetaAdsCTA["SEND_MESSAGE"] = "SEND_MESSAGE";
    MetaAdsCTA["LIKE_PAGE"] = "LIKE_PAGE";
    MetaAdsCTA["CALL_NOW"] = "CALL_NOW";
    MetaAdsCTA["BUY_NOW"] = "BUY_NOW";
    MetaAdsCTA["ORDER_NOW"] = "ORDER_NOW";
})(MetaAdsCTA || (exports.MetaAdsCTA = MetaAdsCTA = {}));
var MetaAdsConversionEvent;
(function (MetaAdsConversionEvent) {
    MetaAdsConversionEvent["PURCHASE"] = "PURCHASE";
    MetaAdsConversionEvent["ADD_TO_CART"] = "ADD_TO_CART";
    MetaAdsConversionEvent["INITIATE_CHECKOUT"] = "INITIATE_CHECKOUT";
})(MetaAdsConversionEvent || (exports.MetaAdsConversionEvent = MetaAdsConversionEvent = {}));
var MetaAdsAttributionWindow;
(function (MetaAdsAttributionWindow) {
    MetaAdsAttributionWindow["ONE_DAY_CLICK"] = "1d_click";
    MetaAdsAttributionWindow["SEVEN_DAY_CLICK"] = "7d_click";
    MetaAdsAttributionWindow["ONE_DAY_VIEW"] = "1d_view";
})(MetaAdsAttributionWindow || (exports.MetaAdsAttributionWindow = MetaAdsAttributionWindow = {}));
// ── Geo-targeting ──
var MetaAdsDistanceUnit;
(function (MetaAdsDistanceUnit) {
    MetaAdsDistanceUnit["MILE"] = "mile";
    MetaAdsDistanceUnit["KILOMETER"] = "kilometer";
})(MetaAdsDistanceUnit || (exports.MetaAdsDistanceUnit = MetaAdsDistanceUnit = {}));
var MetaAdsLocationType;
(function (MetaAdsLocationType) {
    MetaAdsLocationType["HOME_RECENT"] = "home_or_recent";
    MetaAdsLocationType["HOME"] = "home";
    MetaAdsLocationType["RECENT"] = "recent";
    MetaAdsLocationType["TRAVEL_IN"] = "travel_in";
})(MetaAdsLocationType || (exports.MetaAdsLocationType = MetaAdsLocationType = {}));
/** Maps wizard location type to Meta `geo_locations.location_types`. */
function metaAdsLocationTypesForApi(locationType) {
    switch (locationType) {
        case MetaAdsLocationType.HOME:
            return ["home"];
        case MetaAdsLocationType.RECENT:
            return ["recent"];
        case MetaAdsLocationType.TRAVEL_IN:
            return ["travel_in"];
        default:
            return ["home", "recent"];
    }
}
// Targeting mode: determines which geo-targeting method is active
var MetaAdsGeoTargetingMode;
(function (MetaAdsGeoTargetingMode) {
    MetaAdsGeoTargetingMode["RADIUS_PIN"] = "radius_pin";
    MetaAdsGeoTargetingMode["ZIP_CODE"] = "zip_code";
    MetaAdsGeoTargetingMode["CITY_REGION"] = "city_region";
})(MetaAdsGeoTargetingMode || (exports.MetaAdsGeoTargetingMode = MetaAdsGeoTargetingMode = {}));
// ── Audience types ──
var MetaAdsAudienceType;
(function (MetaAdsAudienceType) {
    MetaAdsAudienceType["CUSTOM_LIST"] = "CUSTOM_LIST";
    MetaAdsAudienceType["CUSTOM_WEBSITE"] = "CUSTOM_WEBSITE";
    MetaAdsAudienceType["CUSTOM_ENGAGEMENT"] = "CUSTOM_ENGAGEMENT";
    MetaAdsAudienceType["LOOKALIKE"] = "LOOKALIKE";
})(MetaAdsAudienceType || (exports.MetaAdsAudienceType = MetaAdsAudienceType = {}));
var MetaAdsAudienceStatus;
(function (MetaAdsAudienceStatus) {
    MetaAdsAudienceStatus["POPULATING"] = "POPULATING";
    MetaAdsAudienceStatus["READY"] = "READY";
    MetaAdsAudienceStatus["TOO_SMALL"] = "TOO_SMALL";
    MetaAdsAudienceStatus["ERROR"] = "ERROR";
})(MetaAdsAudienceStatus || (exports.MetaAdsAudienceStatus = MetaAdsAudienceStatus = {}));
var MetaAdsEngagementSource;
(function (MetaAdsEngagementSource) {
    MetaAdsEngagementSource["FB_PAGE"] = "FB_PAGE";
    MetaAdsEngagementSource["IG_PROFILE"] = "IG_PROFILE";
    MetaAdsEngagementSource["LEAD_FORM"] = "LEAD_FORM";
    MetaAdsEngagementSource["VIDEO"] = "VIDEO";
    MetaAdsEngagementSource["EVENTS"] = "EVENTS";
})(MetaAdsEngagementSource || (exports.MetaAdsEngagementSource = MetaAdsEngagementSource = {}));
var MetaAdsWebsiteAudienceRule;
(function (MetaAdsWebsiteAudienceRule) {
    MetaAdsWebsiteAudienceRule["ALL_VISITORS"] = "ALL_VISITORS";
    MetaAdsWebsiteAudienceRule["SPECIFIC_URLS"] = "SPECIFIC_URLS";
    MetaAdsWebsiteAudienceRule["TIME_SPENT"] = "TIME_SPENT";
    MetaAdsWebsiteAudienceRule["CUSTOM_EVENT"] = "CUSTOM_EVENT";
})(MetaAdsWebsiteAudienceRule || (exports.MetaAdsWebsiteAudienceRule = MetaAdsWebsiteAudienceRule = {}));
// ── Approval Workflow ──
var MetaAdsCampaignApprovalStatus;
(function (MetaAdsCampaignApprovalStatus) {
    MetaAdsCampaignApprovalStatus["PENDING"] = "pending";
    MetaAdsCampaignApprovalStatus["APPROVED"] = "approved";
    MetaAdsCampaignApprovalStatus["REJECTED"] = "rejected";
})(MetaAdsCampaignApprovalStatus || (exports.MetaAdsCampaignApprovalStatus = MetaAdsCampaignApprovalStatus = {}));
